import React from 'react';
import { Colors as C } from '../../constants/Colors.js';
import { canShowListingSocialKit, listingSocialContentType } from '../../lib/adminListingSocial.js';

const btnMini = {
  padding: '5px 10px',
  borderRadius: 8,
  border: '0.5px solid rgba(200,168,75,0.35)',
  background: 'rgba(200,168,75,0.08)',
  color: C.gold,
  fontSize: 10,
  fontWeight: 600,
  cursor: 'pointer',
};

const btnRedes = {
  ...btnMini,
  borderColor: 'rgba(120,160,255,0.45)',
  color: 'rgba(180,200,255,0.95)',
};

/**
 * Acciones moderación + hub redes para un listing (mismo patrón que Noticias / Comunidad).
 */
export default function AdminListingSocialActions({
  listing,
  busy = false,
  socialNetworks = [],
  onRedes,
  onActivate,
  onPause,
  onRemove,
  onViewFicha,
  showActivate = true,
  showPauseRemove = true,
}) {
  if (!listing?.id) return null;
  const contentType = listingSocialContentType(listing);
  const canRedes = canShowListingSocialKit(listing);
  const st = String(listing.status || '').toLowerCase();
  const showPauseBtn = showPauseRemove && st === 'active';
  const showRemoveBtn = showPauseRemove && st !== 'removed';
  const showActivateBtn = showActivate && st !== 'active' && st !== 'removed';

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
      {socialNetworks.length > 0 ? (
        <span
          style={{ fontSize: 9, color: 'rgba(93,202,165,0.9)', marginRight: 2 }}
          title={`Publicado en: ${socialNetworks.join(', ')}`}
        >
          ✓ {socialNetworks.join(' · ')}
        </span>
      ) : null}
      {canRedes ? (
        <button
          type="button"
          style={btnRedes}
          disabled={busy}
          onClick={() =>
            onRedes?.({
              contentId: listing.id,
              contentType,
              titleHint: listing.title || listing.artist || '',
            })
          }
        >
          Redes
        </button>
      ) : null}
      <button
        type="button"
        style={btnMini}
        disabled={busy || !onViewFicha}
        onClick={() => onViewFicha?.(listing.id)}
      >
        Ver ficha
      </button>
      {showActivateBtn ? (
        <button
          type="button"
          style={{ ...btnMini, borderColor: 'rgba(29,158,117,0.45)', color: C.green }}
          disabled={busy}
          onClick={() => onActivate?.(listing.id)}
        >
          Activar
        </button>
      ) : null}
      {showPauseBtn ? (
        <button
          type="button"
          style={{ ...btnMini, borderColor: 'rgba(239,159,39,0.55)', color: 'rgba(239,159,39,0.95)' }}
          disabled={busy}
          onClick={() => onPause?.(listing.id)}
        >
          Pausar
        </button>
      ) : null}
      {showRemoveBtn ? (
        <button
          type="button"
          style={{ ...btnMini, borderColor: 'rgba(226,75,74,0.55)', color: C.danger }}
          disabled={busy}
          onClick={() => onRemove?.(listing.id)}
        >
          Retirar
        </button>
      ) : null}
    </div>
  );
}
